import { CSVRow, loadCSVFromData } from "../../../lib/csvLoader";
import { BeautyProfilerAllureId, BeautyProfilerAllure } from "../types/BeautyProfilerAllure";
import { beautyProfilerAlluresData } from "../../../data/beautyProfilerAllures";

export class BeautyProfilerAllureRepository {
  private allures: BeautyProfilerAllure[] = [];
  private isInitialized = false;

  constructor() {
    this.initialize();
  }

  async initialize(): Promise<void> {
    if (this.isInitialized) {
      return;
    }

    try {
      const data = await loadCSVFromData(beautyProfilerAlluresData);
      this.allures = data.map((row: CSVRow) => ({
        id: parseInt(row.id) as BeautyProfilerAllureId,
        label: row.label,
        description: row.description,
      }));

      this.isInitialized = true;
    } catch (error) {
      console.error("Failed to initialize BeautyProfilerAllureRepository:", error);
      throw error;
    }
  }

  getAllureById(id: BeautyProfilerAllureId): BeautyProfilerAllure {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerAllureRepository not initialized. Call initialize() first."
      );
    }
    const allure = this.allures.find((allure) => allure.id === id);
    if (!allure) {
      throw new Error(`Allure with id ${id} not found`);
    }
    return allure;
  }

  getAlluresByIds(ids: BeautyProfilerAllureId[]): BeautyProfilerAllure[] {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerAllureRepository not initialized. Call initialize() first."
      );
    }
    return this.allures.filter((allure) => ids.includes(allure.id));
  }

  getAllAllures(): BeautyProfilerAllure[] {
    if (!this.isInitialized) {
      throw new Error(
        "BeautyProfilerAllureRepository not initialized. Call initialize() first."
      );
    }
    return [...this.allures];
  }

  isReady(): boolean {
    return this.isInitialized;
  }
}

export const beautyProfilerAllureRepository = new BeautyProfilerAllureRepository(); 